import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router'
import { router } from './router'
import { adoptOrgCodeFromQuery } from './lib/org'
import { useAuth } from './lib/auth/store'
import './app.css'

// DCMC 화면이 `/mtt/?org=<코드>` 로 넘겨 준 회사 코드를 받는다.
// 🔴 첫 렌더 전에 저장해야 한다 (org.ts 의 주석 참조)
adoptOrgCodeFromQuery()

// 🔴 위 줄 **뒤에** 다시 읽는다 (2026-09-09).
//   세션 키 접두사에 회사가 들어가는데, 스토어의 첫 읽기는 `./router` 를 import 하는
//   줄에서 이미 끝나 있다 — 그때는 회사 코드가 아직 저장되기 전이다.
//   옛 키 이관도 이 읽기에서 돈다.
useAuth.getState().rehydrate()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 태깅 기록은 서버가 진실이다. 창을 다시 볼 때마다 굳이 다시 부르진 않되,
      // 30초 지난 데이터는 새로 받는다.
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

const root = document.getElementById('root')
if (!root) throw new Error('#root 를 찾을 수 없습니다')

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
)
